import { useState } from 'react';

import WrappedLightMenu from '@crehana/web/LightMenu';

import MainMenuWrapper from './MainMenuWrapper';
import type { MainMenuWithTopBannerProps } from './types';

const LightMenu: React.FC<
  React.PropsWithChildren<MainMenuWithTopBannerProps>
> = props => {
  const [isTopBannerOpen, setIsTopBannerOpen] = useState(false);

  return (
    <MainMenuWrapper
      countryPrefix={props.countryPrefix}
      amplitudePageName={props.amplitudePageName}
      onToggleTopBanner={setIsTopBannerOpen}
      position={props.position}
      {...props.topBannerProps}
    >
      <WrappedLightMenu topBannerIsOpen={isTopBannerOpen} {...props} />
    </MainMenuWrapper>
  );
};

export default LightMenu;
